import { instance } from './axios.instance'
import { PROGRAM_ENDPOINT } from './endpoints'

/**
 * 교육실적 상세
 * GET /api/program/{id}
 * @param {string} id
 */
export const getProgramDetail = id => instance.get(PROGRAM_ENDPOINT.DETAIL(id))

/**
 * 교육실적 삭제
 * DELETE /api/program/{id}
 * @param {string} id
 */
export const deleteProgram = id => instance.delete(PROGRAM_ENDPOINT.DELETE(id))

/**
 * 교육실적 수정
 * PATCH /api/program/{id}
 * @param {string} id
 * @param {Object} data
 */
export const editProgram = (id, data) => {
    const formData = new FormData()
    const body = { ...data }
    delete body.files
    formData.append('body', JSON.stringify(body))

    // 기존 첨부파일은 서버에서 받은 메타데이터 객체(File 아님)라 그대로 append하면
    // "[object Object]"로 직렬화되어 멀티파트 파싱이 깨진다. 신규 선택 파일만 보낸다.
    if (data.files && data.files.length > 0) {
        data.files.filter(file => file instanceof File).forEach(file => {
            formData.append('files', file)
        })
    }
    return instance.patch(PROGRAM_ENDPOINT.EDIT(id), formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
}

/**
 * 교육실적 아카이브 (isCompleted 플래그만 갱신)
 * PATCH /api/program/{id}/archive
 * @param {string} id
 */
export const archiveProgram = id => instance.patch(PROGRAM_ENDPOINT.ARCHIVE(id))

/**
 * 교육실적 등록
 * POST /api/program/create
 * @param {Object} data
 */
export const createProgram = data => {
    const formData = new FormData()
    const body = data.map(item => {
        const { files, ...rest } = item
        return rest
    })
    formData.append('body', JSON.stringify(body))

    data.forEach(item => {
        if (item.files && item.files.length > 0) {
            item.files.filter(file => file instanceof File).forEach(file => {
                formData.append('files', file)
            })
        }
    })

    return instance.post(PROGRAM_ENDPOINT.CREATE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
}
/**
 * 교육실적 목록
 * GET /api/program/list
 * @param {Object} params
 */
export const getProgramList = params => instance.get(PROGRAM_ENDPOINT.LIST, { params })
